import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Breadcrumb,
  Row,
  Col,
  Spinner,
  Dropdown,
  InputGroup
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./LiveAdd.css";
import { Formik } from "formik";
import { connect } from "react-redux";
import useReactRouter from "use-react-router";
import Cookies from 'js-cookie';
import {
  faPlus,
  faTrash,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useToasts } from "react-toast-notifications";
import { COLOR_APP, CREATED, FACEBOOK_BASE_URL, LINEAR_GRADIENT_BG, LINK_SALE_PAGE } from "../../../constants";
import _ from "lodash";
import { imageRender } from "../../../helpers";
import AnimationLoading from "../../../components/AnimationLoading";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_LIVE,
  CREATE_LIVE_WITH_LIVE_STOCK_AND_UPDATE_STOCK,
  UPDATE_LIVE,
} from "../../../graphql/live/mutation";
import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import { GET_STOCK, GET_STOCKS } from "../../../graphql/stock/query";
import {
  CREATE_LIVE_STOCK,
  CREATE_MANY_LIVE_STOCKS,
  DELETE_LIVE_STOCK,
  UPDATE_BULK_WRITE_LIVE_STOCK,
  UPDATE_LIVE_STOCK,
} from "../../../graphql/liveStock/mutation";
import {
  UPDATE_MANY_STOCK,
  UPDATE_STOCK,
} from "../../../graphql/stock/mutation";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import AllProduct from "./AllProduct";
import SelectedProduct from "./SelectedProduct";
import BasicModal from "../../../components/BasicModal";
// import { HiOutlineSwitchHorizontal } from "react-icons/hi";
// import { FaCopy } from "react-icons/fa";
// import { createStock, deleteLiveStock } from "../../../graphql/mutations";
// import copy from "clipboard-copy";
import LoadingSpinner from "../../../components/LoadingSpinner";
import PaginationsV1 from "../../../components/PaginationV1";
// import { errorSwal } from "../../../helpers/sweetalert";
import { MdCreateNewFolder, MdOutlineCancel, MdOutlineNoteAdd, MdOutlineUpdate } from "react-icons/md";


function LiveAdd({ }) {
  let SHOP_ID = localStorage.getItem("SHOP");
  // const shopPageCookie = [{ "access_token": "EAAJ4D9SoBDsBOyl95VD4RZA36tWrqYx4ZBdPIAjc0PjlQLczksB3PvGjhsJopO0AZAnilHYsxveZAZBMoUVyxCzRjuF3w7lakZCfRYBTzs7m1kWhABgfDKEdEAJa0t1CFSyZBINcOVqEjoCFnJ8keWPSOZCAVsA2heXV9PUE95R3lMYNCVucaDM8V6Uv1ERP3c5OZBQ4WtxkATYs6ZBw8ZD", "category": "Software", "category_list": [{ "id": "2211", "name": "Software" }], "name": "Sala Technology", "id": "108526298830349", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE", "MANAGE"] }, { "access_token": "EAAJ4D9SoBDsBO2wt5rNDh8fOJkhr35yva9TP3EtNtJTPWeqZBNX2GA2VH7YNge2kKZAZBqzgNo0XNjPdIoVarWdihVZBT2ULVdTAMkQGeZALJUGRirLWcfZBGOnkNls89UDJdDXK5sKepQ9K00nvX12svpGtWORknOBeXHX7UZCbRC6xe5ZCNL5uA71JVudjmbqx4Iwm4UaFhoZBqd0gZD", "category": "Health/beauty", "category_list": [{ "id": "2214", "name": "Health/beauty" }], "name": "Chii Pam-Ict", "id": "111263485024331", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE", "MANAGE"] }, { "access_token": "EAAJ4D9SoBDsBOx5vPFIoeDyNUBoiZBxZArqeg4svepo60KKYGu6ZCRk9ARHOXpaj3RFstZAwnAstsJ2npzzmaISZAQZCz9I2oa2Rv60wqk9Qs5qgg48TL46bzSE19QyepmZCRJEjdlykZCtGZAHLweyNEbrBduZC00OEbWhsHFBzQjKSQyCbDdCqzZBfLtc0Gt9v4PBp7QbIVscZCwJtJCAZD", "category": "Software Company", "category_list": [{ "id": "1065597503495311", "name": "Software Company" }], "name": "Lailao Learn - ລະບົບຈັດການໂຮງຮຽນ", "id": "102469749097262", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE"] }];
  const shopPageCookie = Cookies.get('SHOP_PAGE');
  // console.log("shopPageCookie:", shopPageCookie)
  const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];

  // const assignedPageList = shopPageCookie;
  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const [showGuide, setShowGuide] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [stockTotal, setStockTotal] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [liveData, setLiveData] = useState();
  const [liveStock, setLiveStock] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSameCode, setIsSameCode] = useState(false);
  const [arrSameCode, setArrSameCode] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isSelectLiveStockAll, setIsSelectLiveStockAll] = useState(false);
  const [dataFromSelect, setDataFromSelect] = useState([]);
  const [selectedTap, setSelectedTap] = useState(0);
  const [showSelect, setShowSelect] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [selectedPage, setSelectedPage] = useState();
  const [selectedPageName, setSelectedPageName] = useState("");
  const [selectedPageId, setSelectedPageId] = useState("");
  const [selectedPageToken, setSelectedPageToken] = useState("");
  const [selectPageFilter, setSelectPageFilter] = useState();

  const [getStockOnShop, { data: userStockData, loading: userStockLoading }] = useLazyQuery(GET_STOCKS, { fetchPolicy: 'cache-and-network' })

  const [getLiveStocks, { data: userLiveStockData, loading: liveStockLoading }] = useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
  const [createLive] = useMutation(CREATE_LIVE);
  const [updateLive] = useMutation(UPDATE_LIVE);
  const [createLiveStock] = useMutation(CREATE_LIVE_STOCK);
  const [createManyLiveStocks] = useMutation(CREATE_MANY_LIVE_STOCKS);
  const [updateLiveStock] = useMutation(UPDATE_LIVE_STOCK);
  const [updateBulkWriteLiveStock] = useMutation(UPDATE_BULK_WRITE_LIVE_STOCK);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [deleteLiveStock] = useMutation(DELETE_LIVE_STOCK);
  const [updateManyStock] = useMutation(UPDATE_MANY_STOCK);
  const [
    createLiveWithLivestockAndUpdateStock,
    { loading: createLiveLoading },
  ] = useMutation(CREATE_LIVE_WITH_LIVE_STOCK_AND_UPDATE_STOCK);

  // const perPageLimit = 800;
  const [perPageLimit, setPerPageLimit] = useState(150);
  const [page, setPage] = useState(0);
  const pageAll = stockTotal > 0 ? Math.ceil(stockTotal / perPageLimit) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  useEffect(() => {
    // getUserStock()
    if (!history.location.state) history.goBack();
    setEditMode(history.location.state?.editMode);
  }, []);

  useEffect(() => {
    if (editMode) {
      setLiveData(history.location.state.data);
      setSelectedPageName(history.location.state?.data?.pageName);
      setSelectedPageId(history.location.state?.data?.page);
    }
  }, [editMode]);

  useEffect(() => {
    if (liveData && editMode) {
      // console.log({ liveData })
      getLiveStock();
    }
  }, [liveData, editMode]);

  useEffect(() => {
    handleFectStocksOnShop()
  }, [page, perPageLimit]);

  const getLiveStock = async () => {
    try {
      await getLiveStocks({
        variables: {
          where: {
            live: liveData?.id,
            isDeleted: false,
          },
          skip: 0,
          limit: 800,
        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };


  // fetch stocks
  const handleFectStocksOnShop = async () => {
    try {
      let _shopId = localStorage.getItem("SHOP");

      if (userStockLoading) return;
      await getStockOnShop({
        variables: {
          where: {
            isDeleted: false,
            shop: _shopId,
            amount: 1,
          },
          orderBy: "createdAt_DESC",
          // limit: 20,
          // skip: 0,
          limit: perPageLimit,
          skip: page * perPageLimit,
        }
      })
    } catch (error) {
      console.log("error", error)
    }
  }

  useEffect(() => {
    if (userStockData?.stocks) {

      // flitterStock(userStockData?.stocks?.data)
      setStockTotal(userStockData?.stocks?.total);
      setStockList(userStockData?.stocks?.data);
    }
  }, [userStockData]);

  const flitterStock = async (data) => {
    if (data.length > 0) {
      const _stockList = data.filter((item) => item.amount > 0);
      setStockTotal(_stockList.length ?? 0);
      setStockList(_stockList);
    } else {
      setStockTotal(0);
      setStockList([]);
    }
  };

  useEffect(() => {
    if (userLiveStockData?.liveStocks?.data) {
      let _userStockData = userLiveStockData?.liveStocks?.data;
      let _validateLiveStock = _userStockData.map((lStock) => {
        return {
          ...lStock,
          validateAmount: lStock?.amount,
        };
      });
      setLiveStock(_validateLiveStock);
    }
  }, [userLiveStockData]);


  const _saveData = (values) => {

    if (editMode) {
      return editLiveV2();
    } else {
      return  _createLive();
    }
  };

  const _createLive = async (values) => {
    try {
      if (isLoading || createLiveLoading) return;
      let isMessageEmpty = false;
      let isAmountEmpty = false;
      liveStock.map(async (liveStock, index) => {
        if (!liveStock.cfMessage) isMessageEmpty = true;
        if (!liveStock.amount) isAmountEmpty = true;
      });
      if (liveStock.length == 0) {
        addToast("ເພີ່ມສິນຄ້າຈະຂາຍໃນໄລຟກ່ອນບັນທຶກ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (isMessageEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງກໍານົດລະຫັດຊີເອຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (isAmountEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງມີຈໍານວນຫຼາຍກວ່າ 1​ ອັນ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      const SHOP_ID = await localStorage.getItem("SHOP");
      setIsLoading(true);
      const liveStocks = liveStock.map((liveStock, index) => {
        return {
          amount: liveStock?.amount,
          amountAll: liveStock?.amount,
          cfMessage: liveStock?.cfMessage,
          stock: liveStock?.stock?.id,
          isDeleted: false,
          shop: SHOP_ID,
        };
      });

      const createLive = await createLiveWithLivestockAndUpdateStock({
        variables: {
          data: {
            live: {
              page: selectedPageId,
              pageName: selectedPageName,
              isDeleted: false,
              status: "CREATED",
              shop: SHOP_ID,
            },
            liveStocks: liveStocks,
          },
        },
      });
      if (createLive?.data?.createLiveWithLiveStockAndUpdateStock?.id) {
        addToast("ເພີ່ມໄລຟສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        history.replace("/live-manage/active/limit/30/page/1");
        return;
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log("error creating todo:", err);
      addToast("ມີຂໍ້ຜິດພາດໃນການເພີ່ມໄລຟ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const _editLive = async (values) => {
    try {
      if (isLoading) return;
      //Check if cfMessage is empty
      let isMessageEmpty = false;
      let isAmountEmpty = false;
      setIsLoading(true);
      liveStock.map(async (liveStock, index) => {
        if (!liveStock.cfMessage) isMessageEmpty = true;
        if (!liveStock.amount) isAmountEmpty = true;
      });
      if (liveStock.length == 0) {
        addToast("ເພີ່ມສິນຄ້າຈະຂາຍໃນໄລຟກ່ອນບັນທຶກ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }
      if (isMessageEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງກໍານົດລະຫັດຊີເອຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }
      if (isAmountEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງມີຈໍານວນຫຼາຍກວ່າ 1​ ອັນ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }

      //Update Live
      await updateLive({
        variables: {
          where: {
            id: liveData?.id,
          },
          data: {
            page: selectedPageId,
            pageName: selectedPageName,
            status: CREATED,
          },
        },
      });

      //Update Live Stock
      liveStock.map(async (lStock, index) => {
        if (lStock.id) {
          //Update Live Stock
          await updateLiveStock({
            variables: {
              where: {
                id: lStock?.id,
              },
              data: {
                amount: lStock.amount,
                amountAll: lStock.amount,
                cfMessage: lStock.cfMessage,
                cfCode: lStock?.cfMessage.toUpperCase(),
              },
            },
          });

        } else {
          //Create new stock when new item added
          let SHOP_ID = await localStorage.getItem("SHOP");
          await createLiveStock({
            variables: {
              data: {
                amount: lStock?.amount,
                amountAll: lStock?.amount,
                cfMessage: lStock?.cfMessage,
                cfCode: lStock?.cfMessage.toUpperCase(),
                stock: lStock?.stock?.id,
                live: liveData?.id,
                isDeleted: false,
                shop: SHOP_ID,
              },
            },
          });
        }
      });
      setIsLoading(false);
      addToast("ແກ້ໄຂໄລຟສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
      history.goBack();
    } catch (err) {
      setIsLoading(false);
      console.log("error creating todo:", err);
      addToast("ມີຂໍ້ຜິດພາດໃນການແກ້ໄຂໄລຟ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };
  
  const editLiveV2 = async (values) => {
    try {
      if (isLoading) return;
      //Check if cfMessage is empty
      let isMessageEmpty = false;
      let isAmountEmpty = false;
      setIsLoading(true);
      liveStock.map(async (liveStock, index) => {
        if (!liveStock.cfMessage) isMessageEmpty = true;
        if (!liveStock.amount) isAmountEmpty = true;
      });
      if (liveStock.length == 0) {
        addToast("ເພີ່ມສິນຄ້າຈະຂາຍໃນໄລຟກ່ອນບັນທຶກ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }
      if (isMessageEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງກໍານົດລະຫັດຊີເອຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }
      if (isAmountEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງມີຈໍານວນຫຼາຍກວ່າ 1​ ອັນ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
        return;
      }

      //Update Live
      await updateLive({
        variables: {
          where: {
            id: liveData?.id,
          },
          data: {
            page: selectedPageId,
            pageName: selectedPageName,
            status: CREATED,
          },
        },
      });

      //Update Live Stock
      const res = await updateBulkWriteLiveStock({
        variables: {
          data: liveStock.map((lStock) => ({
            id: lStock?.id,
            stock: lStock?.stock?.id,
            live: liveData?.id,
            amount: lStock?.amount,
            amountAll: lStock?.amount,
            cfMessage: lStock?.cfMessage,
            cfCode: lStock?.cfMessage.toUpperCase(),
          })),
        },
      });
      if (res?.data?.updateBulkWriteLiveStock?.status) {
        addToast("ແກ້ໄຂໄລຟສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setIsLoading(false);
        history.goBack();
      } else {
        addToast(res?.data?.updateBulkWriteLiveStock?.msg || "ມີຂໍ້ຜິດພາດໃນການແກ້ໄຂໄລຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      console.log("error update bulk write live stock:", err);
      addToast("ມີຂໍ້ຜິດພາດໃນການແກ້ໄຂໄລຟ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const _addStockToLive = (stock) => {
    let _newLiveStock = {
      stock,
      amount: stock.amount,
      amountAll: stock.amount,
      validateAmount: 0,
      cfMessage: stock?.cfMessage ?? "",
    };
    const existingIds = new Set(liveStock.map(stock => stock.id)); // Assuming each stock has an 'id'

    const duplicates = stockList.filter(stock => existingIds.has(stock.id));

    // If duplicates are found, show an alert
    if (duplicates.length > 0) {
      addToast("ສະຕ໋ອກນີ້ໄດ້ເພິ່ມເຂົ້າໄລຟແລ້ວ! ກະລຸນາເລືອກສະຕ໋ອກໃໝ່", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (checkStockIsAdded(stock)) {
      addToast("ມີຢູ່ໃນລາຍການໄລຟແລ້ວບໍ່ສາມາດເພີ່ມຕື່ມໄດ້", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    let _liveStock = [...liveStock, _newLiveStock];
    // _liveStock.push(_newLiveStock)
    setLiveStock(_liveStock);
  };

  const checkStockIsAdded = (stock) => {
    let _liveStock = [...liveStock];
    let isDuplicated = false;
    _liveStock.map((lStock, index) => {
      if (lStock?.stock?.id == stock?.id) isDuplicated = true;
    });
    return isDuplicated;
  };

  const _removeStockFromLive = async (stock) => {
    let _liveStock = [...liveStock];
    let _removeLiveStock = _.remove(_liveStock, stock);

    if (_removeLiveStock[0].id) {
      await deleteLiveStock({
        variables: {
          where: {
            id: _removeLiveStock[0]?.id,
          },
        },
      });
      await updateStock({
        variables: {
          where: {
            id: _removeLiveStock[0]?.stock?.id,
          },
          data: {
            amount:
              _removeLiveStock[0]?.stock?.amount + _removeLiveStock[0]?.amount,
            isUsing: false,
          },
        },
      });

      let _stockList = [...stockList];
      _stockList = _stockList.map((stock) => {
        if (_removeLiveStock[0]?.stock?.id == stock.id) {
          return {
            ...stock,
            amount: _removeLiveStock[0]?.amount + stock?.amount,
          };
        } else return stock;
      });
      setStockList(_stockList);
    }

    setLiveStock(_liveStock);
  };

  const _liveStockChange = (stock, index, e) => {
    let _liveStock = [...liveStock];

    //Check amount is less than stock
    // console.log(_liveStock[index])
    if (
      _liveStock[index].validateAmount + _liveStock[index].stock.amount <
      parseInt(e.target.value)
    ) {
      addToast("ຈໍານວນຂາຍຕ້ອງບໍ່ເກີນໃນສະຕ໋ອກ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (parseInt(e.target.value) <= 0) {
      addToast("ຈໍານວນຕ້ອງການຂາຍຫຼາຍກວ່າຫນຶ່ງຊິ້ນ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    _liveStock[index] = {
      ..._liveStock[index],
      amount: parseInt(e.target.value),
      amountAll: parseInt(e.target.value),
    };
    setLiveStock(_liveStock);
  };

  const _liveStockCFMessageChange = (stock, index, e) => {
    var n = e.target.value.includes("/");
    if (n) {
      addToast("ລະຫັດCFຕ້ອງບໍ່ມີອັກສອນ '/' (ສະແລັສ) ປົນຢູ່!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    let _liveStock = [...liveStock];

    //Check Duplicate CFMessage
    let _isDuplicated = false;
    _liveStock.map((lStock, index) => {
      if (lStock.cfMessage != "" && lStock.cfMessage == e.target.value) {
        _isDuplicated = true;
      }
    });

    if (_isDuplicated) {
      setIsSameCode(true);
      let _arrSameCode = [...arrSameCode];
      _arrSameCode.push(index);
      setArrSameCode(_arrSameCode);
      addToast("ລະຫັດCFຕ້ອງບໍ່ຊໍ້າກັນ​!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else {
      setIsSameCode(false);
      let _arrSameCode = arrSameCode.filter((item) => item != index);
      setArrSameCode(_arrSameCode);
    }

    _liveStock[index] = {
      ..._liveStock[index],
      cfMessage: e.target.value,
    };
    setLiveStock(_liveStock);
  };

  const checkSameCode = (index) => arrSameCode.filter((item) => item == index);

  const onAddAllStocksToLive = async () => {
    try {
      if (dataFromSelect.length > 0) {

        // Extract IDs from the existing liveStock
        const existingIds = new Set(liveStock.map(_data => _data?.stock?.id)); // Assuming each stock has an 'id'

        // Check if any stock in stockList already exists in liveStock
        const duplicates = dataFromSelect.filter(data => existingIds.has(data?.stock?.id));

        // If duplicates are found, show an alert
        if (duplicates.length > 0) {
          addToast("ມີບາງສະຕ໋ອກໄດ້ເພິ່ມເຂົ້າໄລຟແລ້ວ! ກະລຸນາເລືອກສະຕ໋ອກໃໝ່", {
            appearance: "error",
            autoDismiss: true,
          });
          return;
        }

        // Otherwise, update liveStock with new stocks
        setLiveStock((prev) => [...prev, ...dataFromSelect]);

        // Reset selection state
        setIsSelectAll(false);
        setDataFromSelect([])
      }
    } catch (error) {
      console.error("error:::", error)
    }
  };




  const onSeletedAllStocks = async () => {
    if (isSelectAll) {
      setDataFromSelect([]);
      setIsSelectAll(false);
    } else {
      const existingIds = new Set(liveStock.map(_data => _data?.stock?.id));
      let _stockList = [];
      for (var i = 0; i < stockList.length; i++) {
        const s = stockList[i];
        if (existingIds.has(s?.id)) continue;
        _stockList.push({
          stock: s,
          amount: s.amount,
          amountAll: s.amount,
          validateAmount: 0,
          cfMessage: s?.cfMessage ?? "",
        });
      }
      if (_stockList.length === 0) {
        setIsSelectAll(false);
        setDataFromSelect([]);
      } else {
        setDataFromSelect(_stockList);
        setIsSelectAll(true);
      }
    }
  };

  const _goToYoutube = () => {
    window.open("https://www.youtube.com/watch?v=AUZw4n44Dfo", "_blank");
  };

  const { height, width } = useWindowDimensions();

  const onSelectTap = (tap) => {
    setSelectedTap(tap);
  };
  const handleShowCancel = () => {
    triggerHideCancel();
    history.goBack();
  };

  const _changeSeletedPage = async (e, index, live) => {
    if (e.target.value) {
      let _selectPageFilter = _.filter(assignedPageList, {
        id: e.target.value,
      });
      setSelectPageFilter(_selectPageFilter);

    } else {
      setSelectedPage({});
      setSelectedPageName("");
      setSelectedPageId("");
      setSelectedPageToken("");
    }
  };

  const handleSelectThisPage = (item) => {
    setSelectPageFilter(item)
    setSelectedPageId(item?.id)
    setSelectedPageName(item?.name)
    setLiveData({
      ...liveData,
      pageName: item?.name,
    });
    triggerHideSelectPage()
  }


  const _onSavePage = () => {
    if (assignedPageList?.length === 0 || !selectPageFilter)
      return triggerHideSelectPage();
    setLiveData({
      ...liveData,
      pageName: selectPageFilter[0]?.name ?? liveData?.pageName,
    });
    setSelectedPageName(selectPageFilter[0]?.name ?? "");
    setSelectedPageId(selectPageFilter[0]?.id ?? "");
    triggerHideSelectPage();
    return;
  };

  const _deleteLiveStockAndUpdateStock = async (lStock) => {
    try {
      await deleteLiveStock({
        variables: {
          where: {
            id: lStock?.id,
          },
        },
      });
      await updateStock({
        variables: {
          where: {
            id: lStock?.stock?.id,
          },
          data: {
            amount: lStock?.stock?.amount + lStock?.amount,
            isUsing: false,
          },
        },
      });
    } catch (error) {
      console.log("error", error)
    }
  };

  const _handleRemoveLiveStockAll = async () => {
    if (isLoading) return;
    setIsLoading(true);
    if (editMode) {
      liveStock.map(async (lStock, index) => {
        await _deleteLiveStockAndUpdateStock(lStock);
      });
    }
    setLiveStock([]);
    setIsSelectLiveStockAll(false);
    setIsLoading(false);
  };

  const handlePerPageChange = (limit) => {
    setPerPageLimit(limit); // Update the perPageLimit state
    setPage(0); // Reset page to 0 when perPageLimit changes
  };


  const triggerHideSelectPage = () => setShowSelect(false);
  const triggerShowSelect = () => setShowSelect(true);
  const triggerHideCancel = () => setShowCancel(false);
  const triggerShowCancel = () => setShowCancel(true);


  return (
    <div>
      {width > 700 ? (
        <div style={{ background: "#F1F1F1", }}>

          <Breadcrumb>
            <Breadcrumb.Item
              style={{ fontSize: 14, color: COLOR_APP }}
              onClick={() =>
                history.replace("/live-manage/active/limit/30/page/1")
              }>
              <FontAwesomeIcon
                icon={faVideo}
                style={{ marginRight: 6, color: COLOR_APP }}
              />
              <span style={{ color: COLOR_APP }}>ຈັດການໄລຟ</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active>
              {editMode ? "ແກ້ໄຂຂໍ້ມູນໄລຟ" : "ເພີ່ມຂໍ້ມູນການໄລຟ"}
            </Breadcrumb.Item>
          </Breadcrumb>

          {(!editMode || liveData) && (
            <Formik
              initialValues={{
                title: liveData?.title || "",
                description: liveData?.description || "",
              }}
              validate={(values) => { }}
              onSubmit={(values) => {
                if (!selectedPageId)
                  return addToast("ກະລຸນາເລືອກ Page ໃດຫນຶ່ງກ່ອນ!", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                if (liveStock.length > 0) {
                  // editMode ? _editLive(values) : _createLive(values)
                  _saveData();
                } else {
                  addToast(
                    "ກະລຸນາເລືອກສິນຄ້າເຂິ້າ Live ກ່ອນ ຈຶ່ງສາມາດເລີ່ມ Live ໄດ້!",
                    {
                      appearance: "error",
                      autoDismiss: true,
                    }
                  );
                }
              }}>
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexdirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                  </div>
                  <div className="searchBar">
                    <div style={{ display: "flex" }}>
                      {/* <span
                        style={{
                          display: "flex",
                          fontSize: "18px",
                          alignItems: "center",
                          marginRight: "10px",
                        }}>
                        ເພຈ Facebook :
                      </span>{" "} */}
                      <div
                        style={{
                          background: "#F9F9F9",
                          minWidth: 440,
                          height: "46px",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyItems: "center",
                          verticalAlign: "centered",
                          fontWeight: 'bold', fontSize: 26
                        }}>
                        {assignedPageList?.length > 0 ? (
                          <span>
                            {liveData?.pageName === "undefined" ||
                              liveData?.pageName === ""
                              ? "ກະລຸນາເລືອກ Page ກ່ອນ"
                              : liveData?.pageName ?? "ກະລຸນາເລືອກ Page ກ່ອນ"}
                          </span>
                        ) : (
                          <span style={{ opacity: "80%" }}>
                            ກະລຸນາເຊື່ອມຕໍ່ Facebook
                          </span>
                        )}
                      </div>
                      <Button
                        // id={isLogged ? "" : "btn-disable"}
                        onClick={triggerShowSelect}
                        variant="outlinelight"
                        className="btn-select">
                        ເລືອກເພຈ
                      </Button>
                    </div>

                    <div className="d-flex gap-2">
                      <Button
                        variant="light"
                        size="lg"
                        style={{ minWidth: 120, }}
                        onClick={triggerShowCancel}>
                        <MdOutlineCancel /> ຍົກເລີກ
                      </Button>
                      <Button
                        size="lg"
                        style={{ minWidth: 120, background: LINEAR_GRADIENT_BG }}
                        onClick={() => handleSubmit()}>
                        {isLoading ? (
                          <Spinner size="sm" animation="border" />
                        ) : !editMode ? (
                          <><MdCreateNewFolder /> ສ້າງໄລຟ</>

                        ) : (
                          <><MdOutlineUpdate /> ແກ້ໄຂໄລຟ</>

                        )}
                      </Button>
                    </div>
                  </div>
                  <div style={{ height: 10 }} />
                  {/* <div style={{ background: "#eee", borderRadius: 5, padding: 15, margin: 0 }} className="column">
                            <div className="row">
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="ຄົ້ນຫາຕາມຄໍາສັບ . . . . ." onChange={(e) => _updateListStock(e.target.value)}></input>
                                </div>
                            </div>
                        </div> */}
                  <div className="product-container">
                    <div className="product_wrapper">
                      <div className="d-flex justify-content-between w-100">
                        <h1>
                          ສິນຄ້າໃນສະຕ໋ອກ {stockTotal} ລາຍການ
                        </h1>
                        <Button
                          // variant="outline-light"
                          style={{
                            background: "#F7F7F7",
                            border: "none",
                            color: "#422F90",
                          }}
                          disabled={!isSelectAll}
                          className="add-product-btn"
                          onClick={() => onAddAllStocksToLive()}>
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ marginRight: 5 }}
                          />
                          ເພີ່ມສິນຄ້າ
                        </Button>
                      </div>
                      <div className="control-wrapper">
                        <div className="d-flex justify-content-center align-items-start gap-1 mt-2">
                          <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic">
                              ສະແດງ {perPageLimit}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => handlePerPageChange(150)}>150/ໜ້າ</Dropdown.Item>
                              <Dropdown.Item onClick={() => handlePerPageChange(800)}>800/ໜ້າ</Dropdown.Item>
                              <Dropdown.Item onClick={() => handlePerPageChange(1000)}>1000/ໜ້າ</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          <PaginationsV1
                            count={stockTotal}
                            perPageLimit={perPageLimit}
                            page={page}
                            pageAll={pageAll}
                            onPageChange={handleChangePage}
                            textNext=">"
                            textPrev="<"
                          />
                        </div>

                      </div>

                      {userStockLoading && !userStockData?.stocks ? <LoadingSpinner /> : (
                        <div style={{ overflowY: 'auto', height: '80vh' }}>
                          <Table
                            style={{
                              marginTop: "20px",
                              borderCollapse: "collapse",
                              width: "100% ",
                            }}>
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    textAlign: "center",
                                  }}>
                                  <Form.Check
                                    type="checkbox"
                                    inline
                                    label="#"
                                    checked={isSelectAll}
                                    onClick={() => onSeletedAllStocks()}
                                  />
                                </th>
                                <th
                                  style={{
                                    borderBottom: "none",
                                    textAlign: "center",
                                  }}>
                                  ຮູບ
                                </th>
                                <th style={{ borderBottom: "none" }}>
                                  ຊື່ສິນຄ້າ
                                </th>
                                <th style={{ borderBottom: "none" }}>ລະຫັດCF</th>
                                <th style={{ borderBottom: "none" }}>ຍັງເຫຼືອ</th>
                                <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {stockList.length > 0 &&
                                stockList.map((stock, index) => (
                                  <tr key={index}>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}>
                                      <Form.Check
                                        label={page * perPageLimit + index + 1}
                                        inline
                                        type="checkbox"
                                        disabled
                                        checked={isSelectAll}
                                        value={stock?.id}
                                      />
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      <img
                                        src={imageRender(stock?.image)}
                                        alt=""
                                        style={{
                                          borderRadius: "10%",
                                          width: "40px",
                                          height: "40px",
                                        }}
                                      />
                                    </td>
                                    <td>{stock?.name ?? "-"}</td>
                                    <td>{stock?.cfMessage}</td>
                                    <td>{stock?.amount}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          height: "100%",
                                        }}>
                                        {checkStockIsAdded(stock) ? (
                                          <a
                                            className="btn"
                                            style={{ color: "#616161" }}>
                                            ເພີ່ມແລ້ວ
                                          </a>
                                        ) : stock?.amount != 0 ? (
                                          <a
                                            className="btn hoverme"
                                            disabled={isSelectAll}
                                            onClick={() => {
                                              if (isSelectAll) return;
                                              _addStockToLive(stock);
                                            }}
                                            style={{
                                              borderColor: !isSelectAll
                                                ? COLOR_APP
                                                : "grey",
                                              color: !isSelectAll
                                                ? COLOR_APP
                                                : "grey",
                                              cursor: !isSelectAll
                                                ? "pointer"
                                                : "no-drop",
                                            }}>
                                            <FontAwesomeIcon
                                              icon={faPlus}
                                              style={{
                                                color: !isSelectAll
                                                  ? COLOR_APP
                                                  : "grey",
                                              }}
                                            />{" "}
                                            ເພີ່ມ
                                          </a>
                                        ) : (
                                          <div />
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      )}

                    </div>
                    <div className="product_wrapper">
                      <h1>ສິນຄ້າໃນໄລຟ {liveStock?.length ?? 0} ລາຍການ</h1>
                      <div className="control-wrapper">
                        <div className="empty-divs"></div>
                        <div>

                          <Button
                            disabled={!isSelectLiveStockAll}
                            style={{
                              color: "#D21C1C",
                              fontSize: "16px",
                              borderRadius: "6px",
                              background: "#F7F7F7",
                              border: "none",
                            }}
                            onClick={() => _handleRemoveLiveStockAll()}>
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{ marginRight: 5 }}
                            />
                            ນຳອອກ
                          </Button>
                        </div>
                      </div>
                      <div style={{ overflowY: 'auto', height: '80vh' }}>
                        {liveStock?.length === 0 ? (
                          <div className="no_product">
                            <img src={"images/no_product.png"} alt="" />
                            <h1>ເພີ່ມສິນຄ້າເຂົ້າໃນໄລຟ</h1>
                          </div>
                        ) : (
                          <Table
                            style={{
                              marginTop: "20px",
                              borderCollapse: "collapse",
                              width: "100% ",
                            }}>
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    borderBottom: "none",
                                  }}>
                                  <Form.Check
                                    label="ລຳດັບ"
                                    id="ລຳດັບ"
                                    inline
                                    type="checkbox"
                                    checked={isSelectLiveStockAll}
                                    onClick={() =>
                                      setIsSelectLiveStockAll(
                                        !isSelectLiveStockAll
                                      )
                                    }
                                  />
                                </th>
                                <th style={{ borderBottom: "none" }}>
                                  ຊື່ສິນຄ້າ
                                </th>
                                <th style={{ borderBottom: "none" }}>
                                  ລະຫັດCF
                                </th>
                                <th style={{ borderBottom: "none" }}>
                                  ຈຳນວນທີ່ຈະຂາຍ
                                </th>
                                <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                liveStockLoading ? 
                                <AnimationLoading/> :
                              <>
                                {liveStock?.length > 0 &&
                                  liveStock?.map((product, index) => (
                                    <tr id="trActionCell" key={index}>
                                      <td>
                                        <Form.Check
                                          label={index + 1}
                                          id={index + 1}
                                          inline
                                          type="checkbox"
                                          disabled
                                          value={product?.cfMessage}
                                          checked={isSelectLiveStockAll}
                                        />
                                      </td>
                                      <td>{product?.stock?.name ?? "-"} </td>
                                      <td style={{ width: "135px" }}>
                                        <Form.Control
                                          type="text"
                                          onChange={(e) => {
                                            _liveStockCFMessageChange(
                                              product,
                                              index,
                                              e
                                            );
                                          }}
                                          value={liveStock[index].cfMessage}
                                          placeholder="CFລະຫັດ..."
                                        />
                                        {checkSameCode(index).length > 0 && (
                                          <span
                                            style={{
                                              color: "red",
                                              fontSize: 12,
                                            }}>
                                            ລະຫັດCFຕ້ອງບໍ່ຊໍ້າກັນ​!
                                          </span>
                                        )}
                                      </td>
                                      <td style={{ width: "140px" }}>
                                        <Form.Control
                                          type="number"
                                          onChange={(e) => {
                                            _liveStockChange(product, index, e);
                                          }}
                                          value={liveStock[index].amount}
                                          placeholder="ຈໍານວນ..."
                                        />
                                      </td>
                                      <td>
                                        <div
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                          }}>
                                          <Button
                                            variant="outline-danger"
                                            onClick={() =>
                                              _removeStockFromLive(product)
                                            } >
                                            <FontAwesomeIcon icon={faTrash} />
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </>
                              }
                            </tbody>
                          </Table>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          )}

          <Modal
            show={showGuide}
            onHide={() => setShowGuide(false)}
            keyboard={false}
            dialogClassName="modal-90w modal-dialog2"
            aria-labelledby="example-custom-modal-styling-title"
            centered>
            <div
              className="text-center"
              style={{
                background: "white",
                paddingLeft: 40,
                width: "89vw",
              }}>
              <Col>
                <Row>
                  <img
                    className="d-block"
                    src={"/images/Tutorial-Live.jpg"}
                    alt="Third slide"
                    style={{ width: "100%" }}
                  />
                </Row>
                <Row
                  style={{
                    background: "white",
                    justifyContent: "end",
                    paddingBottom: 16,
                    paddingRight: 16,
                  }}>
                  <button
                    className="btn btn-primary"
                    style={{ width: 130, marginRight: 10 }}
                    onClick={() => setShowGuide(false)}>
                    ເຂົ້າໃຈແລ້ວ
                  </button>

                  <button
                    className="btn btn-primary"
                    style={{
                      background: "#E8EDF1",
                      color: "black",
                      width: 240,
                      height: 44,
                      marginLeft: 10,
                      display: "flex",
                      justifyContent: "space-evenly",
                    }}>
                    <p
                      style={{ paddingTop: 2 }}
                      onClick={(e) => {
                        _goToYoutube();
                        setShowGuide(false);
                      }}>
                      ເບິ່ງວິທີໃຊ້ງານທີ່ Youtube
                    </p>
                    <FontAwesomeIcon
                      icon={faYoutube}
                      style={{ width: 30, height: 30, color: "red" }}
                    />
                  </button>
                </Row>
              </Col>
            </div>
          </Modal>
          <BasicModal
            show={showCancel}
            onHide={triggerHideCancel}
            okay={handleShowCancel}
            title="ທ່ານຕ້ອງການຍົກເລີກການສ້າງໄລຟ ຫລື ບໍ່"
            leftButtonName="ຍົກເລີກ"
            rightButtonName="ຕົກລົງ"
            Illustration={"images/Illustration.png"}
          />
        </div>
      ) : (
        <div style={{ padding: 10 }}>

          <div style={{ position: 'fixed', right: 0, bottom: 0, padding: 10, zIndex: 999 }}>
            <Button
              style={{
                background: LINEAR_GRADIENT_BG,
                border: "none",
                borderRadius: 5,
                fontWeight: "bold",
                padding: "8px 20px"
              }}
              onClick={() => {
                if (!selectedPageId)
                  return addToast("ກະລຸນາເລືອກ Page ໃດຫນຶ່ງກ່ອນ!", {
                    appearance: "error",
                    autoDismiss: true,
                  });
                _saveData();
                // if (editMode) return _editLive();
                // _createLive();
              }}>
              {" "}
              {isLoading ? <Spinner size="sm" animation="border" /> : <><MdOutlineNoteAdd style={{ fontSize: 28 }} /> ສ້າງໄລຟ</>}
            </Button>

          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}>

            <Breadcrumb style={{ width: '100%' }}>
              <Breadcrumb.Item onClick={() => history.push(`/live-manage/active/limit/30/page/1`)}>ຈັດການໄລຟ</Breadcrumb.Item>
              <Breadcrumb.Item active>
                ສ້າງໄລຟ
              </Breadcrumb.Item>
            </Breadcrumb>


          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <InputGroup className="mb-3">
              <InputGroup.Text id="basic-addon1">ເພຈ:</InputGroup.Text>
              <Form.Select
                value={
                  selectPageFilter
                    ? selectPageFilter[0]?.id
                    : liveData?.page ?? ""
                }
                onChange={(e) => {
                  _changeSeletedPage(e, 1, liveData);
                  let _selectPageFilter = _.filter(assignedPageList, {
                    id: e.target.value,
                  });
                  setSelectedPageName(_selectPageFilter[0]?.name ?? "");
                  setSelectedPageId(_selectPageFilter[0]?.id ?? "");
                }}>
                <option value="">ເລືອກເພຈເຊື່ອມຕໍ່</option>
                {assignedPageList?.map((page, pIndex) => {
                  return (
                    <option value={page?.id} key={"page" + pIndex}>
                      {page?.name}
                    </option>
                  );
                })}
              </Form.Select>
            </InputGroup>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
              height: 30,
              width: "100%",
              marginTop: 16,
              paddingLeft: 8,
              paddingRight: 8,
            }}>
            <div
              onClick={() => onSelectTap(0)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderBottom:
                  "1px solid " + (selectedTap == 0 ? "#1b1b1b" : "#bebebe"),
                width: "50%",
                color: selectedTap == 0 ? "#1b1b1b" : "#777",
                height: 30,
              }}>
              ສິນຄ້າ ({stockList.length ?? 0})
            </div>
            <div
              onClick={() => onSelectTap(1)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderBottom:
                  "1px solid " + (selectedTap == 1 ? "#1b1b1b" : "#bebebe"),
                width: "50%",
                color: selectedTap == 1 ? "#1b1b1b" : "#555",
                height: 30,
              }}>
              ສິນຄ້າທີ່ເພີ່ມ ({liveStock.length ?? 0})
            </div>
          </div>
          <div>
            {selectedTap == 1 ? (
              <SelectedProduct
                liveStock={liveStock ?? []}
                setLiveStock={setLiveStock}
                removeStockFromLive={_removeStockFromLive}
                handleRemoveLiveStockAll={_handleRemoveLiveStockAll}
                liveStockChange={_liveStockChange}
              />
            ) : (
              <AllProduct
                liveStock={liveStock ?? []}
                userStockLoading={userStockLoading}
                products={stockList ?? []}
                checkStockIsAdded={checkStockIsAdded}
                addStockToLive={_addStockToLive}
                setLiveStock={setLiveStock}
                page={page}
                pageAll={pageAll}
                handleChangePage={handleChangePage}
                stockTotal={stockTotal}
                perPageLimit={perPageLimit}
                handlePerPageChange={handlePerPageChange}
              />
            )}
          </div>
        </div>
      )}

      <Modal show={showSelect} onHide={triggerHideSelectPage}>
        {assignedPageList?.length > 0 && <Modal.Header closeButton>
          <Modal.Title
            style={{
              padding: "10px 0.5px 0px 0.5px",
              color: "#00072B",
              fontSize: "16px",
            }}>
            ເລືອກເພຈທີ່ທ່ານຕ້ອງການສ້າງໄລຟ
          </Modal.Title>
        </Modal.Header>}
        <Modal.Body>
          {assignedPageList?.length > 0 ? (
            <>
              {assignedPageList.map((item, index) => (
                <div onClick={() => handleSelectThisPage(item)} key={index} style={{ background: liveData?.pageName === item?.name ? "#ddd" : "#fff" }} className="card-page-selected">
                  <img src="https://cdn-icons-png.flaticon.com/512/11820/11820184.png" style={{ width: 45, height: 45, borderRadius: "50em", overflow: 'hidden', border: '1px solid #f2f2f2' }} />
                  <p style={{ fontSize: 18, fontWeight: 'bold' }}>{item?.name}</p>
                </div>
              ))}
            </>
          ) : (
            <div className="w-100 p-4 d-flex justify-content-center align-items-center flex-column gap-2">
              <img src="https://i.pinimg.com/736x/03/c1/59/03c1592000149644661c721f5aed48fb.jpg" alt="empty page" style={{ maxWidth: 135, maxHeight: 135, }} />
              <p>ກະລຸນາເຊື່ອມຕໍ່ Facebook ກ່ອນ</p>
            </div>
          )}

        </Modal.Body>
        {/* <Modal.Body>
          {assignedPageList?.length > 0 ? (
            <Form.Control
              as="select"
              value={
                selectPageFilter
                  ? selectPageFilter[0]?.id
                  : liveData?.page ?? ""
              }
              onChange={(e) => _changeSeletedPage(e, 1, liveData)}>
              <option value="">ເລືອກເພຈເຊື່ອມຕໍ່</option>
              {assignedPageList?.map((page, pIndex) => {
                return (
                  <option value={page?.id} key={"page" + pIndex}>
                    {page?.name}
                  </option>
                );
              })}
            </Form.Control>
          ) : (
            <p>ກະລຸນາເຊື່ອມຕໍ່ Facebook ກ່ອນ</p>
          )}
          <div
            style={{
              textAlign: "center",
              alignItems: "center",
              marginTop: "27px",
            }}>
            <Button
              variant="secondary"
              onClick={triggerHideSelectPage}
              style={{
                background: "#E8EDF1",
                color: "#252A31",
                border: "none",
                marginRight: "10px",
                width: "62px",
                height: "33px",
                fontSize: "12px",
              }}>
              ຍົກເລີກ
            </Button>
            <Button
              variant="primary"
              onClick={() => _onSavePage()}
              style={{
                background: "#371895",
                color: "#FFFFFF",
                border: "none",
                width: "59px",
                height: "33px",
                textAlign: "center",
                fontSize: "12px",
              }}>
              ບັນທຶກ
            </Button>
          </div>
        </Modal.Body> */}
      </Modal>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(LiveAdd);
